<template>
  <div class="wrapper">
    <p v-if="balanceSheets.length<=0 && showLoading===false" class="center" style="margin-top:12px;font-size: 14px;">暂无记录</p>
    <SheetItem
      v-for="item in balanceSheets"
      v-else
      :key="item.balanceSheetId"
      :month="item.month"
      :company-name="item.companyName"
      :to="`/balance-sheet-detail/${item.balanceSheetId}`"/>
  </div>
</template>

<script>
  import {mapActions, mapGetters} from 'vuex';
  import SheetItem from '../../components/SheetItem';

  export default {
    name: "BalancesSheets",
    components: {
      SheetItem
    },
    computed: {
      ...mapGetters(['balanceSheets','showLoading'])
    },
    methods: {
      ...mapActions(['getBalanceSheets'])
    },
    created() {
      window.document.title = '资产负债表';
      this.getBalanceSheets();
    }
  }
</script>

<style scoped>

</style>